export default __webpack_public_path__ + "static/media/robinpay.32203220.svg";